import React from 'react';
import { Paper, Grid, Box, Typography } from '@material-ui/core';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import useBooking from '../../../../context/useBooking';
import { useTranslations } from 'components/utilities';

const BookingDetailsHeader = ({ boxPaddings, isDesktop }) => {
	const { t } = useTranslations();

	const { booking } = useBooking();

	return (
		<Paper>
			<Box {...boxPaddings}>
				<Grid container spacing={1} justify="space-between" alignItems="center">
					<Grid item xs="auto">
						<Grid container spacing={1} alignItems="center">
							<Grid item xs="auto">
								<AssignmentTurnedInIcon
									fontSize={isDesktop ? 'large' : 'default'}
								/>
							</Grid>
							<Grid item xs="auto">
								<Typography>{t('booking.bookingId')}</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs="auto">
						<Typography variant="h5">{booking.u_id}</Typography>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};

export default BookingDetailsHeader;
